import { IApplicationState } from '../types/redux';

export const newbuildingUrlSelector = (state: IApplicationState): string => {
  return state.newbuilding.newbuildingPath;
};
